import { z } from 'zod'
import { isValidRut } from '@/shared/utils/rutValidator'

// --- Client (API response) ---
export interface Client {
  id: number
  name: string
  last_name: string
  rut: string
  phone_number: string
  gender: string
  commune: string
  birthdate: string
  email: string
  id_company: number
  id_branch_office: number
  client_test: boolean
  created_at: string | null
}

// --- Client Status (from GET /status_client/{id}) ---
export interface ClientStatus {
  id_client: number
  id_company: number
  available_points: number
  category: string | null
}

// --- Form schema for create/edit ---
export const clientFormSchema = z.object({
  name: z.string().min(1, 'Nombre es requerido'),
  last_name: z.string().min(1, 'Apellido es requerido'),
  rut: z
    .string()
    .min(1, 'RUT es requerido')
    .refine((val) => isValidRut(val), { message: 'RUT inválido' }),
  phone_number: z.string().max(20, 'Teléfono muy largo (max 20 caracteres)').optional().default(''),
  gender: z.string().optional().default(''),
  commune: z.string().optional().default(''),
  birthdate: z.string().optional().default(''),
  email: z.string().email('Email inválido'),
  id_branch_office: z.number({ required_error: 'Sucursal es requerida' }),
  client_test: z.boolean().optional().default(false),
})

export type ClientFormData = z.infer<typeof clientFormSchema>

// --- Filters for list ---
export interface ClientFilters {
  page: number
  limit: number
  search?: string
  commune?: string
  gender?: string
  last_known_category?: string
  id_branch_office?: number
  created_from?: string
  created_to?: string
  sort_by?: string
  sort_order?: 'asc' | 'desc'
}
